const config = {
    // -----------------------------
    // 🎲 Game
    // -----------------------------
    game: {
        intro: true,
        debug: false,
        dev: false,
        stats: false,
        follow: true,
        shadows: true,
        music: true,
    },

    // -----------------------------
    // ▨ Zones
    // -----------------------------
    zone1: {
        id: 'ZONE1',
        zone: 1,
        colour: '#9FC7E3',
        width: 12.5,
        height: 1,
        depth: 64,
        position: {
            x: -9.5,
            y: 0,
            z: 0
        }
    },
    zone2: {
        id: 'ZONE2',
        zone: 2,
        colour: '#9FC7E3',
        width: 6.4,
        height: 1,
        depth: 64,
        position: {
            x: 0,
            y: 0,
            z: 0
        }
    },
    zone3: {
        id: 'ZONE3',
        zone: 3,
        colour: '#9FC7E3',
        width: 12.5,
        height: 1,
        depth: 64,
        position: {
            x: 9.5,
            y: 0,
            z: 0
        }
    },


    // -----------------------------
    // 💨 Wind
    // -----------------------------
    wind: {
        direction: 0,
        intensity: 0.05,
    },

    // -----------------------------
    // ▨ Pane
    // -----------------------------
    pane: {
        colour: 0x3fca00,
        width: 5.6,
        height: 40,
        depth: 0.01,
        position: {
            x: 0,
            y: (40 / 2) + 3.0,
            z: -25
        },
    },

    // -----------------------------
    // 🎥 Camera
    // -----------------------------
    camera: {
        smoothing: 0.005,
        perspective: {
            fov: 50,
            near: 0.1,
            far: 100,
        },
        distance: {
            min: 4,
            max: 4,
        },
        polar: {
            min: Math.PI / 4,
            max: Math.PI / 2,
        },
        polar_predict: {
            min: Math.PI / 3,
            max: Math.PI / 2,
        },
        azimuth_predict: {
            min: -Math.PI / 6,
            max: Math.PI / 6,
        },
    },

    // -----------------------------
    // 🟩 Ground
    // -----------------------------
    ground: {
        colour: '#4D982F',
        width: 19,//3.6842105263
        height: 34.5,//2.8985507246
        depth: 0.01,
        friction: 0.9,
    },

    // -----------------------------
    // 🏉 Ball
    // -----------------------------
    ball: {
        mass: 1,
        restitution: 0.35,
        height: 0.22,
        diameter: 0.39,
        launch_strength: 15,// was 9.9
        max_launch_strength: 16,
        default_launch_angle: 30,
        friction: 0.9,
        shear: 0.25,
        angular_damping: 0.8,
        max_angular_velocity: 10,
    },

    // -----------------------------
    // ☁️ Clouds
    // -----------------------------
    clouds: {
        shear: 8,
        count: 14,
        scale: { min: 4, max: 14 },
        opacity: { min: 0.55, max: 0.9 },
        altitude: { min: 14, max: 34 },
        depth: { min: -55, max: -30 },
    },

    // -----------------------------
    // ☁️ Background clouds (large, faint, further back than the main field)
    // -----------------------------
    cloudsBack: {
        count: 6,
        scale: { min: 24, max: 38 },
        opacity: { min: 0.12, max: 0.28 },
        altitude: { min: 5, max: 12 },
        depth: { min: -85, max: -60 },
        // Draw before the logo regardless of transparent-sort order, since the logo's
        // glTF globe material is also transparent/depthWrite:false (see Clouds.js).
        renderOrder: -1,
    },

    // -----------------------------
    // ☁️ Pitch clouds (fixed layout, visible from the gameplay camera)
    // -----------------------------
    // Positions/scales carried over from the original low-poly cloud1.glb-cloud10.glb
    // meshes so the sprite replacements sit exactly where the artist placed them.
    pitchClouds: {
        altitude: { min: 4.9, max: 14.1 },
        depth: { min: -42.3, max: -35.6 },
        layout: [
            { x: -10.35, y: 11.91, z: -41.70, scale: 2.57 },
            { x: 13.76, y: 9.00, z: -38.61, scale: 2.29 },
            { x: -19.44, y: 11.17, z: -36.29, scale: 2.75 },
            { x: 5.48, y: 14.09, z: -42.25, scale: 2.52 },
            { x: -2.04, y: 7.13, z: -35.65, scale: 1.51 },
            { x: 6.50, y: 5.96, z: -41.70, scale: 0.51 },
            { x: -13.32, y: 4.90, z: -38.61, scale: 1.72 },
            { x: 24.46, y: 5.30, z: -36.29, scale: 2.06 },
            { x: 20.96, y: 11.91, z: -41.70, scale: 0.77 },
            { x: -22.90, y: 5.15, z: -42.25, scale: 1.51 },
        ],
    },

    // -----------------------------
    // 📍 Positions
    // -----------------------------
    positions: {
        reset: {
            x: 0,
            y: 0.28,
            z: -0
        },
        predict: {
            x: 0,
            y: 0.28,
            z: -22
        },
        close: {
            x: 0,
            y: 0.28,
            z: -0
        },
    },

    // -----------------------------
    //  Shot clock
    // -----------------------------
    shot_clock: {
        display: {
            width: 5.4,
            depth: 1,
            height: 3.4,
            position: { x: 0, y: (3.4 / 2) + 3.45, z: -35.1 },
        },
        post: {
            diameter: 0.435,
            depth: 0.8,
            height: 5,
            position: { x: 0, y: (5 / 2) - .1, z: -35.3 },
        }
    },

    // -----------------------------
    //  Padding Left
    // -----------------------------
    paddingLeft: {
        width: 0.8,
        depth: 0.8,
        height: 2,
        position: { x: -2.8, y: (2 / 2) - .1, z: -24.95 },
        colour0: '#34465C',
        colour1: '#86C6FF',
        colour2: '#294f70',
        colour3: '#8DABBC',
        colour4: '#ffffff'
    },

    paddingRight: {
        width: 0.8,
        depth: 0.8,
        height: 2,
        position: { x: 2.8, y: (2 / 2) - .1, z: -24.95 },
        colour0: '#34465C',
        colour1: '#86C6FF',
        colour2: '#294f70',
        colour3: '#8DABBC',
        colour4: '#ffffff'
    },

    postLeft: {
        diameter: 0.13,
        height: 20,
        position: { x: -2.8, y: (20 / 2), z: -24.95 },
        colour: '#fff',
    },

    postRight: {
        diameter: 0.13,
        height: 20,
        position: { x: 2.8, y: (20 / 2), z: -24.95 },
        colour: '#fff',
    },

    postMiddle: {
        diameter: 0.13,
        height: 5.6,
        position: { x: 0, y: 3, z: -24.95 },
        colour: '#fff',
    },

    // -----------------------------
    // 🏙️ Sky
    // -----------------------------
    sky: {
        radius: 50,
        detail: 2,
        colours: [
            '#DD8420',
            '#D7D28F',
            '#83C7DC',
        ],
        stops: [
            0.5,
            0.55,
            0.4,
        ],
    },

    // -----------------------------
    // 💡 Lights
    // -----------------------------
    lights: {
        floor: {
            colour: 0xd9e5ec,
            intensity: 2
        }
    },


    constants: {
        asset_directory: `${window.location.origin}/_resources/themes/mercury/dist/3D/`,
    },



};
export default config;